import Flickity from 'flickity';

export default class LandingPageHero {
  constructor() {
    this.$el = document.querySelector('.js-landing-page-hero')
    if (!this.$el) return;

    this.$carousels = this.$el.querySelectorAll('.js-landing-page-hero-logo-carousel');

    this.$carousels.forEach($carousel => new Flickity($carousel, {
      imagesLoaded: true,
      prevNextButtons: false,
      pageDots: true,
      autoPlay: 3000,
    }));
  }
}
